import React from 'react';
import InputWithSearch from '../common/InputWithSearch';

export const ChatSearch = ({ search, setSearch, placeholder = 'Search...' }) => {
    return (
        <InputWithSearch
            search={search}
            onClear={() => setSearch('')}
            onChange={(e) => setSearch(e.target.value)}
            placeholder={placeholder}
            className={'ms-1 me-2 chat-search'}
            mainStyle={{ maxHeight: '32px' }}
        />
    );
};
